module.exports = __webpack_public_path__ + "img/moved_en.1688ddc0.png";